import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor() {}

  isAuthenticated(): boolean {
    const token = localStorage.getItem('crmtoken');
    return !!token;
  }

  logout(): void {
    localStorage.removeItem('crmtoken');
  }
}